import { render, staticRenderFns } from "./HowDoWeCalcThisModal.vue?vue&type=template&id=4cd58c47&scoped=true&"
import script from "./HowDoWeCalcThisModal.vue?vue&type=script&lang=ts&"
export * from "./HowDoWeCalcThisModal.vue?vue&type=script&lang=ts&"
import style0 from "./HowDoWeCalcThisModal.vue?vue&type=style&index=0&id=4cd58c47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd58c47",
  null
  
)

export default component.exports